interface SeletorQuantidadeProps {
  quantidade: number;
  maximo: number;
  aoMudar: (v: number) => void;
}

const ATALHOS = [1, 2, 5, 10];

export default function SeletorQuantidade({
  quantidade,
  maximo,
  aoMudar,
}: SeletorQuantidadeProps) {
  const limite = Math.max(1, maximo);

  function definir(v: number) {
    const valor = Math.min(Math.max(1, v), limite);
    aoMudar(valor);
  }

  const atalhosVisiveis = ATALHOS.filter((a) => a <= limite);

  return (
    <div>
      <div className="flex items-center justify-center gap-4">
        <button
          type="button"
          onClick={() => definir(quantidade - 1)}
          disabled={quantidade <= 1}
          aria-label="Diminuir"
          className="flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-secondary-300 bg-white text-2xl text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
        >
          −
        </button>

        <div className="w-20 text-center">
          <span className="text-[40px] font-bold leading-none text-foreground-950">
            {quantidade}
          </span>
        </div>

        <button
          type="button"
          onClick={() => definir(quantidade + 1)}
          disabled={quantidade >= limite}
          aria-label="Aumentar"
          className="flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border border-secondary-300 bg-white text-2xl text-foreground-800 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
        >
          +
        </button>
      </div>

      <div className="mt-2 text-center text-sm text-secondary-500">números</div>

      {atalhosVisiveis.length > 0 && (
        <div className="mt-3 flex items-center justify-center gap-2">
          {atalhosVisiveis.map((a) => (
            <button
              key={a}
              type="button"
              onClick={() => definir(a)}
              className={`flex h-9 w-9 cursor-pointer items-center justify-center whitespace-nowrap rounded-full border text-sm font-medium transition-colors ${
                quantidade === a
                  ? 'border-primary-500 bg-primary-500 text-white'
                  : 'border-secondary-300 bg-white text-foreground-800 hover:bg-background-100'
              }`}
            >
              {a}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}